import { LessonIndexView } from './lessons';
import { ImageRef } from '../../commonv3/types/image';
import { CourseExamShowView } from './courseExams';
import { CourseCategoryShowView } from './courseCategories';

export type CourseId = number;

export type CourseIndexView = {
  id: CourseId;
  title: string;
  sub_title: string;
  overview: string;
  thumbnail: ImageRef;
  card_bg: ImageRef;
  card_eyecatch: ImageRef;
  reviewer_skill_type_id: number;
  lesson_count: number;
  completed: boolean;
  duration_in_minutes: number;
  has_work: boolean;
  writing_exam_count: number;
  practical_exam_count: number;
  course_category?: CourseCategoryShowView | null;
  new_course: boolean;
};

export type CourseShowView = {
  id: CourseId;
  title: string;
  overview: string;
  thumbnail: ImageRef;
  lessons: LessonIndexView[];
  lesson_count: number;
  exams: CourseExamShowView[];
  card_bg: ImageRef;
  card_eyecatch: ImageRef;
  detail_eyecatch: ImageRef;
  detail_eyecatch_sp: ImageRef;
  completed: boolean;
  past_course: boolean;
  completion_certificate: string | null;
  writing_exam_count: number;
  practical_exam_count: number;
  completed_practical_count: number;
  completed_writing_count: number;
  course_category?: CourseCategoryShowView;
};

export const DESIGN_EXERCISE_COURSE_Id = 81;
export const ILLUSTRATOR_COURSE_ID = 82;
export const WORDPRESS_COURSE_ID = 90;
export const LOGO_CI_COURSE_ID = 33;
export const UI_UX_COURSE_ID = 31;
export const WRITING_FIRST_COURSE_ID = 92;
export const WEB_WRITING_COURSE_ID = 91;
export const BRANDING_COURSE_ID = 47;
export const DIRECTOR_COURSE_ID = 26;
export const PROJECT_MANAGEMENT_COURSE_ID = 56;
export const BUSINESS_COURSE_ID = 21;
export const SELF_BRANDING_COURSE_ID = 66;
export const MARKETING_FIRST_COURSE_ID = 48;
export const SNS_MARKETING_COURSE_ID = 41;
export const CAMERA_COURSE_ID = 87;
export const FREELANCE_COURSE_ID = 19;
export const CONTENTS_MARKETING_COURSE_ID = 43;
export const WORK_TRIAL_COURSE_ID = 3;
export const PR_COURSE_ID = 39;
export const COPY_WRITING_COURSE_ID = 83;
export const ADVERTISING_OPERATION_COURSE_ID = 40;
export const WEB_DESIGN_FIRST_COURSE_ID = 44;
export const WEB_DESIGN_COURSE_ID = 42;
export const WEB_MARKETING_COURSE_ID = 49;
export const TUTORIAL_COURSE_ID = 38;
